export default __webpack_public_path__ + "static/step0302-d15428b83bf705979f53d4d171364f4b.png";